import { Link } from "react-router-dom";
import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { JOURNEY } from "../lib/site";

export default function StudentJourney() {
  return (
    <>
      <PageHero
        label="The Student Journey"
        title={<>From discovering a voice to <em className="font-italic-accent italic gold-text">making impact</em>.</>}
        subtitle="Every BTSA learner walks through five intentional stages — a progression of confidence, craft and character that lasts a lifetime."
      />

      <section data-testid="journey-stages" className="ivory-section py-24 lg:py-32">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="relative">
            <div className="absolute left-[34px] lg:left-[58px] top-4 bottom-4 w-px bg-gradient-to-b from-transparent via-[#d4af37]/40 to-transparent" />
            <ul className="space-y-12 lg:space-y-16">
              {JOURNEY.map((j, i) => (
                <Reveal key={j.n} delay={i * 0.06}>
                  <li data-testid={`journey-${j.n}`} className="relative pl-24 lg:pl-40">
                    <div className="absolute left-0 top-0 flex items-center gap-4 lg:gap-6">
                      <div className="h-[68px] w-[68px] lg:h-[96px] lg:w-[96px] grid place-items-center hairline bg-[#0a0a0a]">
                        <span className="font-serif text-2xl lg:text-3xl gold-text">{j.n}</span>
                      </div>
                    </div>
                    <div>
                      <div className="section-label">{j.subtitle}</div>
                      <h3 className="mt-4 font-serif text-3xl lg:text-4xl text-white font-medium uppercase tracking-wide">
                        {j.title}
                      </h3>
                      <p className="mt-4 font-sans text-base lg:text-lg text-white/65 leading-relaxed font-light max-w-2xl">
                        {j.desc}
                      </p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#080808] border-y border-white/5">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <Reveal>
            <div className="flex justify-center"><SectionLabel>Outcomes</SectionLabel></div>
            <h2 className="mt-6 font-serif text-3xl lg:text-4xl text-white font-medium uppercase tracking-wide">
              The five lifelong gifts
            </h2>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              {["Confidence", "Communication", "Creativity", "Leadership", "Stage Presence"].map((o) => (
                <span key={o} className="px-6 py-3 hairline font-sans text-[11px] tracking-[0.28em] uppercase text-[#d4af37]">{o}</span>
              ))}
            </div>
            <div className="mt-12">
              <Link to="/join" className="btn-gold font-sans text-[11px] tracking-[0.3em] uppercase px-9 py-5 font-semibold inline-block">Begin Your Journey</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
